/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Privacy_PolicyInputs */

const en_us2_profile_privacy_policy = /** @type {(inputs: Profile_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy policy`)
};

const pt_br2_profile_privacy_policy = /** @type {(inputs: Profile_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de privacidade`)
};

const es_419_profile_privacy_policy = /** @type {(inputs: Profile_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de privacidad`)
};

const pt_pt2_profile_privacy_policy = /** @type {(inputs: Profile_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de privacidade`)
};

const fr_fr2_profile_privacy_policy = /** @type {(inputs: Profile_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politique de confidentialité`)
};

const de_de2_profile_privacy_policy = /** @type {(inputs: Profile_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutzerklärung`)
};

const it_it2_profile_privacy_policy = /** @type {(inputs: Profile_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informativa sulla privacy`)
};

/**
* | output |
* | --- |
* | "Privacy policy" |
*
* @param {Profile_Privacy_PolicyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_privacy_policy = /** @type {((inputs?: Profile_Privacy_PolicyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Privacy_PolicyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_privacy_policy(inputs)
	if (locale === "es-419") return es_419_profile_privacy_policy(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_privacy_policy(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_privacy_policy(inputs)
	if (locale === "de-DE") return de_de2_profile_privacy_policy(inputs)
	if (locale === "it-IT") return it_it2_profile_privacy_policy(inputs)
	return en_us2_profile_privacy_policy(inputs)
});
export { profile_privacy_policy as "profile.privacy_policy" }